
import { Routes, Route, Navigate } from 'react-router-dom';
import Index from '@/pages/Index';
import DomainExperts from '@/pages/DomainExperts';
import Psychologists from '@/pages/Psychologists';
import CareerCounselors from '@/pages/CareerCounselors';
import CareerSelection from '@/pages/CareerSelection';
import Assessment from '@/pages/Assessment';
import Results from '@/pages/Results';
import Payment from '@/pages/Payment';
import PaymentSuccess from '@/pages/PaymentSuccess';
import BookingPaymentSuccess from '@/pages/BookingPaymentSuccess';
import BookSession from '@/pages/BookSession';
import BookingDialogPage from '@/pages/partners/BookingDialog';
import NotFound from '@/pages/NotFound';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import ProtectedRoute from '@/components/ProtectedRoute';
import ContactUs from '@/pages/ContactUs';
import TermsAndConditions from '@/pages/TermsAndConditions';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import ShippingDelivery from '@/pages/ShippingDelivery';
import CancellationRefund from '@/pages/CancellationRefund';
import MyOrders from '@/pages/MyOrders';
import FAQ from '@/pages/FAQ';
import AdminChangePassword from './pages/admin/ChangePassword';

// Admin Routes
import AdminLogin from '@/pages/admin/Login';
import AdminSetup from '@/pages/admin/Setup';
import Dashboard from '@/pages/admin/Dashboard';
import AdminCareerCounselors from '@/pages/admin/CareerCounselors';
import AdminDomainExperts from '@/pages/admin/DomainExperts';
import AdminPsychologists from '@/pages/admin/Psychologists';
import DetailedListing from '@/pages/admin/DetailedListing';
import AdminProtectedRoute from '@/components/admin/AdminProtectedRoute';
import CouponManagement from '@/pages/admin/CouponManagement';
import SilverUsers from '@/pages/admin/SilverUsers';
import StudyAbroadInsights from '@/pages/admin/StudyAbroadInsights';

import './App.css';

function App() {
  return (
    <main className="min-h-screen">
      {/* Routes configuration */}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Index />} />
        <Route path="/domain-experts" element={<DomainExperts />} />
        <Route path="/psychologists" element={<Psychologists />} />
        <Route path="/career-counselors" element={<CareerCounselors />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shipping-delivery" element={<ShippingDelivery />} />
        <Route path="/cancellation-refund" element={<CancellationRefund />} />
        <Route path="/faq" element={<FAQ />} />
        
        {/* Protected routes */}
        <Route path="/career-selection" element={<ProtectedRoute><CareerSelection /></ProtectedRoute>} />
        <Route path="/assessment" element={<ProtectedRoute><Assessment /></ProtectedRoute>} />
        <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
        <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/booking-payment-success" element={<ProtectedRoute><BookingPaymentSuccess /></ProtectedRoute>} />
        <Route path="/my-orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
        <Route path="/book-session" element={<ProtectedRoute><BookSession /></ProtectedRoute>} />
        <Route path="/partners/booking-dialog" element={<ProtectedRoute><BookingDialogPage /></ProtectedRoute>} />
        
        {/* Admin Routes */}
        <Route path="/administrator/login" element={<AdminLogin />} />
        <Route path="/administrator/setup" element={<AdminSetup />} />
        <Route path="/administrator/dashboard" element={<AdminProtectedRoute><Dashboard /></AdminProtectedRoute>} />
        <Route path="/administrator/career-counselors/*" element={<AdminProtectedRoute><AdminCareerCounselors /></AdminProtectedRoute>} />
        <Route path="/administrator/domain-experts" element={<AdminProtectedRoute><AdminDomainExperts /></AdminProtectedRoute>} />
        <Route path="/administrator/psychologists" element={<AdminProtectedRoute><AdminPsychologists /></AdminProtectedRoute>} />
        <Route path="/administrator/coupon-management" element={<AdminProtectedRoute><CouponManagement /></AdminProtectedRoute>} />
        <Route path="/administrator/silver-users" element={<AdminProtectedRoute><SilverUsers /></AdminProtectedRoute>} />
        <Route path="/administrator/study-abroad-insights" element={<AdminProtectedRoute><StudyAbroadInsights /></AdminProtectedRoute>} />
        <Route path="/administrator/:listType" element={<AdminProtectedRoute><DetailedListing /></AdminProtectedRoute>} />
        
        {/* Root catch-all route for unknown paths - must be last */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
  );
}

export default App;
